import { STORAGE_KEYS } from './storage-keys';
import { logger } from '../utils/logger';

/**
 * Dev mode configuration and utilities
 * Allows running the app in browser without Telegram WebApp
 */

export const isDevMode = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }
  
  try {
    const localStorageValue = window.localStorage.getItem(STORAGE_KEYS.DEV_MODE);
    if (localStorageValue !== null) {
      return localStorageValue === "true";
    }
  } catch {
    // Private WebViews can deny storage before the app has even mounted.
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  const urlDevMode = urlParams.get("dev");
  if (urlDevMode !== null) {
    return urlDevMode === "true";
  }
  
  const envDevMode = import.meta.env?.VITE_DEV_MODE === "true";
  
  return envDevMode;
};

export const enableDevMode = (): void => {
  if (typeof window !== "undefined") {
    localStorage.setItem(STORAGE_KEYS.DEV_MODE, "true");
    logger.log("[DevMode] Enabled. Reload page to apply changes.");
  }
};

export const disableDevMode = (): void => {
  if (typeof window !== "undefined") {
    localStorage.setItem(STORAGE_KEYS.DEV_MODE, "false");
    logger.log("[DevMode] Disabled. Reload page to apply changes.");
  }
};
